import Grid from "@mui/material/Grid";
import ProductCard from "../ProductCard";

export default function GridListProductCard({ products, isOpen }) {
	return (
		<Grid
			container
			size={12}
			spacing={2}
			alignItems="center"
		>
			{products.map((p) => (
				<Grid
					size={{
						xs: 6,
						sm: 4,
						md: 3,
						lg: 2,
					}}
					key={p.rowKey}
				>
					<ProductCard
						categorie={p.categorie}
						name={p.name}
						stock={p.quantite}
						unite={p.unite}
						cover={p.cover}
						prix={p.prix}
						id={p.rowKey}
						isOpen={isOpen}
					/>
				</Grid>
			))}
		</Grid>
	);
}
